import React, { ReactNode } from 'react';
import css from './MessageBanner.module.css';
import { H3, Paragraph } from '../../text';
import { Image } from '../../images';
import clsx from 'clsx';
import { BannerType } from './BannerType';

export interface MessageBannerProps {
  imageSource: string;
  imageAlternateText: string;
  title?: string;
  text?: string;
  content?: ReactNode;
  bannerType: BannerType;
}

const imageSize = 18;

const MessageBanner: React.FC<MessageBannerProps> = (
  props: MessageBannerProps
) => {
  let bannerContainerClass = css.bannerContainerInformation;
  let leftLineClass = css.leftLineInformation;

  if (props.bannerType === BannerType.Error) {
    bannerContainerClass = css.bannerContainerError;
    leftLineClass = css.leftLineError;
  } else if (props.bannerType === BannerType.Success) {
    bannerContainerClass = css.bannerContainerSuccess;
    leftLineClass = css.leftLineSuccess;
  } else if (props.bannerType === BannerType.Warning) {
    bannerContainerClass = css.bannerContainerWarning;
    leftLineClass = css.leftLineWarning;
  }

  return (
    <div className={clsx(css.bannerContainer, bannerContainerClass)}>
      <div className={clsx(css.leftLine, leftLineClass)} />
      <div className={css.bannerContents}>
        <div className={css.imageContainer}>
          <Image
            source={props.imageSource}
            alternateText={props.imageAlternateText}
            width={imageSize}
            height={imageSize}
          />
        </div>
        <div>
          {props.title ? (
            <div>
              <H3 className={css.bannerTitle} text={props.title} />
            </div>
          ) : null}
          {props.text ? (
            <div>
              <Paragraph text={props.text} />
            </div>
          ) : null}
          {props.content ? props.content : null}
        </div>
      </div>
    </div>
  );
};

export default MessageBanner;
